<template>
    <!-- <b-modal id="bv-modal-bank-history" size="lg" title="Bank File History" dialog-class="w-1200" hide-footer > --> <!-- Rejwan: 30-06-2025 Modal Problem --> 
    <b-modal :id="modal_id" size="lg" title="Bank File History" dialog-class="w-1200" hide-footer >
    <b-overlay :show="showoverlayapprove" rounded="sm">
       
        <table class="table table-hover">
            <tbody>
                <tr class="table-head">
                
                    <td class="text-center">Date of Activity </td>
                    <td class="text-center">Status</td>
                    <td class="text-center">Bank File</td>
                    <td class="text-center">Activity by</td>
                    <td class="text-center">Remarks</td>
                
                </tr>
            <template v-if="paginatedData.length">
                <tr class="table-row" v-for="(log,index) in paginatedData" :key="log.id">
                    <td>{{  formatMe(log.updated_at)  }} | {{ formatTime(log.updated_at) }}   </td>
                    <td>{{log.action_type}}</td> 
                    <td>
                        <div class="" style="text-align: center;" v-if="log.file_link != '' && log.file_link != null">                            
                            <b-link @click="download_bank_file(log.file_link)">
                                <b-icon icon="download" scale="2"></b-icon>
                            </b-link>
                        </div>
                
                        <div v-else></div>
                    </td>                
                    <td>{{log.comment_by_name}}</td>
                    <td>{{log.comment}}</td>                
                </tr>
                
                <tr v-if="paginatedData.length > 0"><td :colspan=6>
                        <div class="row p-2 float-right" >
                            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                </div></td></tr>
                
                
                </template>
                <template v-else>
                <tr>
                    <td colspan="7">{{log_not_available}}</td>
                </tr>
                </template>
                
            </tbody>
        </table>
    </b-overlay>
    </b-modal>
</template>
<style scoped>
button.disabled{cursor: default;}
</style>

<script>

import moment from 'moment';
    export default{
        // props: ['pageurl','instrument_id','instrument_type'], // Rejwan: 30-06-2025 Modal Problem
        props: ['modal_id', 'pageurl','instrument_id','instrument_type'], // Rejwan: 30-06-2025 Modal Problem       
        data(){
            return {
                company_name: '',
                pgurl:this.pageurl,
                showoverlayapprove: false,
                approval_data: [],  
                logs : [],             
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                search : '',
                search_by_id:{payrun_id:'', payrun_id_form:''},
                per_page:10,  
                sortOrders: {},         
            }
        },
        methods:{   
            getlogs: function()
            {
            
                this.showoverlay = true;
                this.log_not_available = 'Loading please wait....';
                

                let currentObj = this;
                let formData = new FormData();
                formData.append('instrument_id', this.instrument_id); 
                formData.append('instrument_type', this.instrument_type); 
                axios.post(this.$api_url+'/bank-file-history' , formData).then(function(response){
                this.logs = response.data;
                this.pagination.from = response.data.from;
                this.pagination.to = response.data.to;
                this.pagination.total = response.data.total;
                
                this.showoverlay = false;
                if(this.logs && this.logs.length > 0)
                this.log_not_available = '';
                else
                this.log_not_available = 'No history to show.';
                
                if(this.pagination.to==this.pagination.total)
                {
                    this.pagination.nextbuttonstatus = 'disabled';
                }
                else
                {
                    this.pagination.nextbuttonstatus = '';
                }
                
                if(this.pagination.from==1)
                {
                this.pagination.prebuttonstatus = 'disabled';
                }
                else
                {
                    this.pagination.prebuttonstatus = ''; 
                }

                if(this.pagination.currentPage < response.data.last_page)
                    this.pagination.nextPage = this.pagination.currentPage + 1;

                if(this.pagination.currentPage == 1)
                    this.pagination.prevPage = 1;
                else 
                    this.pagination.prevPage = this.pagination.currentPage - 1;


                // this.$bvModal.show('bv-modal-bank-history'); // Rejwan: 30-06-2025 Modal problem
                this.$bvModal.show(this.modal_id);  // Rejwan: 30-06-2025 Modal problem
                }.bind(this));
            },  
            download_bank_file(file_link)
            {
                this.downloadFileContent(file_link); 
            },       
            formatMe(d)
            {
               return moment(d).format('MMMM D, Y');
            },
            
            formatTime (d)
            {
                return moment(d).format('hh:mm:ss A');
            },
        },
        created: function(){
            if(this.instrument_id != 0 && this.instrument_type != 0)
            {
                this.getlogs();
            }
            else
            {
                // this.$bvModal.hide('bv-modal-bank-history'); // Rejwan: 30-06-2025 Modal problem
                this.$bvModal.show(this.modal_id); // Rejwan: 30-06-2025 Modal problem
            }
            
        },
        computed: 
        {
        filteredData() 
        {
            let filtered_list = this.logs;
            if (this.search) 
            {
                filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
            
                if(filtered_list.length == 0)
                    this.blankmsg = "Nothing found.";                
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) 
            {
                filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                        a = String(a[sortKey]).toLowerCase();
                        b = String(b[sortKey]).toLowerCase();
                        if (this.columns[index].type && this.columns[index].type === 'date') 
                        {
                            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                        } 
                        else if (this.columns[index].type && this.columns[index].type === 'number') 
                        {
                            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                        } 
                        else 
                        {
                            return (a === b ? 0 : a > b ? 1 : -1) * order;
                        }
                    }
                );
            }
            
            return filtered_list;
        },
        paginatedData() 
        {     
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },


        }
    }
</script>
